import React from 'react'
import { useDispatch } from 'react-redux'
import {  toast } from 'react-toastify';
import { updateVehicle } from '../../firebase-services/db-services'
import { getVehiclesFetch } from '../../Redux/slices/vehicleState'
import handleChange from '../../Utils/HandleChange'
import { FormInput, FormRow } from '../Controls/Input'


export default function UpdateVehicle({ formData,setFormData }) {
  const dispatch = useDispatch()
    const changeHandler = handleChange(formData, setFormData)
    const submitHandler = (e) => {
        e.preventDefault()
        if (!formData.docid) return alert("Record Not selected!")
        updateVehicle(formData.docid,formData).then(res=>{
            dispatch(getVehiclesFetch())
            toast.success("Vehicle Detail Updated Successfully")
            //ScrollToTargetAdjusted('transactionTable')
          }).catch(e=>{
            toast.error("Failed to update Vehicle's Detail")
            console.log(e)
          })
        
    }
  return (
    <div id='updateVehicleForm' className="bg-gray-100 p-8 rounded-md mx-auto my-36 w-full max-w-7xl">
    <form className='w-full'>
      <h1 className='text-2xl sm:text-3xl md:text-4xl font-bold tracking-wide mb-7'>Update Vehicle</h1>
      <FormRow mx={3}>
        <FormInput name='name' type="text" label='Vehicle Name' onChange={changeHandler} placeholder={"Party Name"}  value={formData.name} />
        <FormInput name='vehicle_num' type='text' label='Vehicle No.' placeholder='9756721202' onChange={changeHandler} value={formData.vehicle_num} />
      </FormRow>
      <FormRow mx={3}>
        <FormInput name='trolly_num' label='Trolly No.' onChange={changeHandler} placeholder="Vehicle's Address" value={formData.trolly_num} />
      </FormRow>

      <div className='flex flex-row gap-4 mx-4'>
        <button
          className="hover:bg-[#4f48ee] rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
          onClick={submitHandler}
        >
          Submit
        </button>
        <input type="reset"
          className="hover:bg-gray-600 cursor-pointer rounded-md bg-gray-500 py-3 px-8 text-center text-base font-semibold text-white outline-none"
        />
      </div>
    </form>
  </div>
  )
}
